import { ClipboardCheck, ListChecks, ShieldCheck } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const links = [
  { to: "/", label: "Returns", icon: ClipboardCheck },
  { to: "/owner", label: "Owner review", icon: ShieldCheck },
];

export default function AppHeader() {
  const location = useLocation();
  const ownerMode = location.pathname.startsWith("/owner");

  return (
    <header className="app-header" data-testid="app-header">
      <div className="header-inner">
        <Link className="brand" to="/" data-testid="parakh-home-link">
          <span className="brand-mark"><ListChecks size={20} aria-hidden="true" /></span>
          <span>Parakh</span>
        </Link>
        <nav className="app-nav" aria-label="Main navigation">
          {links.map(({ to, label, icon: Icon }) => (
            <Link
              className={location.pathname === to ? "nav-link is-active" : "nav-link"}
              to={to}
              key={to}
              data-testid={`header-${label.toLowerCase().replace(" ", "-")}-link`}
            >
              <Icon size={16} aria-hidden="true" />
              <span>{label}</span>
            </Link>
          ))}
        </nav>
        <Link
          className="role-switch"
          to={ownerMode ? "/" : "/owner"}
          data-testid="role-switch-button"
        >
          <span className="role-switch-dot" aria-hidden="true" />
          {ownerMode ? "Switch to Operator" : "Switch to Owner"}
        </Link>
      </div>
    </header>
  );
}